import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sa-input-boolean',
  templateUrl: './sa-input-boolean.component.html',
  styleUrls: ['../formfields.css']
})
export class SainputbooleanComponent implements OnInit {
  @Input() checked = "";
  @Input() title = "";
  @Input() required = "none"; // P.S. can be 'text' (if required) or 'none' if not required

  @Output() checkedChange = new EventEmitter();
  @Output() hasChanged = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  change(newValue: any) { // P.S. newValue has the changed text

    this.checked = newValue;

    // P.S. Synchronize the text with the model of the parent
    this.checkedChange.emit(newValue);
    this.hasChanged.emit(newValue);
  };
}
